import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../i18n/hooks';
import './SurebetListSkeleton.css';

/**
 * SurebetListSkeleton - Loading skeleton for surebet list
 * Shows placeholder cards while data is being fetched
 */
const SurebetListSkeleton = ({ className = '', count = 3 }) => {
  const { t } = useTranslation();

  return (
    <div 
      className={`surebet-list-skeleton ${className}`}
      role="status"
      aria-label={t('surebets.list.loading')}
    >
      {/* Header skeleton */}
      <div className="surebet-list-skeleton__header">
        <div className="surebet-list-skeleton__title skeleton-shimmer"></div>
        <div className="surebet-list-skeleton__actions">
          <div className="surebet-list-skeleton__button skeleton-shimmer"></div>
          <div className="surebet-list-skeleton__text skeleton-shimmer"></div>
        </div>
      </div>

      {/* Card skeletons */}
      <div className="surebet-list-skeleton__container">
        {[...Array(count)].map((_, index) => (
          <div key={index} className="surebet-card-skeleton">
            {/* Header skeleton */}
            <div className="surebet-card-skeleton__header">
              <div className="surebet-card-skeleton__event-info">
                <div className="surebet-card-skeleton__title skeleton-shimmer"></div>
                <div className="surebet-card-skeleton__subtitle skeleton-shimmer"></div>
              </div>
              <div className="surebet-card-skeleton__event-meta">
                <div className="surebet-card-skeleton__date skeleton-shimmer"></div>
                <div className="surebet-card-skeleton__time skeleton-shimmer"></div>
              </div>
            </div>

            {/* Margins skeleton */}
            <div className="surebet-card-skeleton__margins">
              <div className="surebet-card-skeleton__margins-header">
                <div className="surebet-card-skeleton__label skeleton-shimmer"></div>
                <div className="surebet-card-skeleton__label skeleton-shimmer"></div>
                <div className="surebet-card-skeleton__label skeleton-shimmer"></div>
                <div className="surebet-card-skeleton__label skeleton-shimmer"></div>
              </div>

              {/* Margin rows skeleton */}
              {[...Array(2)].map((_, rowIndex) => (
                <div key={rowIndex} className="surebet-card-skeleton__margin-row">
                  <div className="surebet-card-skeleton__margin-type skeleton-shimmer"></div>
                  <div className="surebet-card-skeleton__coefficients">
                    <div className="surebet-card-skeleton__coefficient skeleton-shimmer"></div>
                    <div className="surebet-card-skeleton__coefficient skeleton-shimmer"></div>
                  </div>
                  <div className="surebet-card-skeleton__profit skeleton-shimmer"></div>
                  <div className="surebet-card-skeleton__actions skeleton-shimmer"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <span className="sr-only">{t('surebets.list.loading')}</span>
    </div>
  );
};

SurebetListSkeleton.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
};

export default SurebetListSkeleton;

